(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["autv-redesign-hero"] && !Shopify.designMode) return;
  try {
    
function initializeAutvHeroes(root) {
  root.querySelectorAll('.autv-intro').forEach(function (hero) {
    const video = hero.querySelector('video');
    const toggle = hero.querySelector('[data-autv-video-toggle]');
    if (!video || !toggle || toggle.dataset.initialized) return;
    toggle.dataset.initialized = 'true';
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    function updateLabel() { toggle.textContent = video.paused ? toggle.dataset.play : toggle.dataset.pause; }
    function updateMotion() { if (reduced.matches) video.pause(); }
    updateMotion();
    reduced.addEventListener('change', updateMotion);
    video.addEventListener('play', updateLabel);
    video.addEventListener('pause', updateLabel);
    video.addEventListener('error', function () { video.style.display = 'none'; toggle.hidden = true; });
    toggle.addEventListener('click', function () { if (video.paused) { video.play().catch(updateLabel); } else { video.pause(); } });
    updateLabel();
  });
}
initializeAutvHeroes(document);
document.addEventListener('shopify:section:load', function (event) { initializeAutvHeroes(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["autv-vehicle-directory"] && !Shopify.designMode) return;
  try {
    
function initializeVehicleDirectories() {
  document.querySelectorAll('[data-autv-directory]').forEach(function (directory) {
    const search = directory.querySelector('[data-autv-directory-search]');
    if (search.dataset.initialized) return;
    search.dataset.initialized = 'true';
    const result = directory.querySelector('[data-autv-directory-results]');
    function filter() {
      const terms = search.value.toLowerCase().replace(/[^a-z0-9 ]/g, ' ').split(/\s+/).filter(Boolean);
      let count = 0;
      directory.querySelectorAll('[data-autv-directory-group]').forEach(function (group) {
        let visible = 0;
        group.querySelectorAll('[data-autv-directory-link]').forEach(function (link) {
          const text = link.dataset.autvDirectorySearchable.toLowerCase().replace(/[^a-z0-9 ]/g, ' ');
          link.hidden = !text.replace(/\s+/g, ' ').includes(terms.join(' '));
          if (!link.hidden) { count += 1; visible += 1; }
        });
        group.hidden = visible === 0;
      });
      result.textContent = result.dataset.countTemplate.replace('__count__', count);
      directory.querySelector('[data-autv-directory-empty]').hidden = count > 0;
    }
    search.addEventListener('input', filter);
    filter();
  });
}
initializeVehicleDirectories();
document.addEventListener('shopify:section:load', initializeVehicleDirectories);

  } catch(e) { console.error(e); }
})();
})();
